<script setup lang="ts">
import { bemBuilder, toMoney } from "@chatfood/core-utils";
import { AtomText } from "@chatfood/design-system";
import { useBasketStore } from "~/stores/basket";
import { useBusinessStore } from "~/stores/business";
import { useLocale } from "~/composables/use-locale";

const css = bemBuilder("guest-price");

const { t } = useLocale();

const business = useBusinessStore();
const basket = useBasketStore();
</script>

<template>
  <AtomText
    v-if="
      business.isCatering && typeof basket.pax === 'number' && basket.pax > 0
    "
    :class="css('')"
    data-test="guest-price"
    color="color-text-secondary"
  >
    <span>
      {{ t("components.guest_price.serves_label", { count: basket.pax }) }}
    </span>
    <span>
      {{
        t("components.guest_price.amount_label", {
          amount: toMoney(
            basket.totalBreakdown.outstandingBalance.value / basket.pax,
            basket.totalBreakdown.outstandingBalance.currency,
          ),
        })
      }}
    </span>
  </AtomText>
</template>

<style lang="scss" scoped>
.guest-price {
  display: flex;
  gap: var(--spacing-sm);
  justify-content: space-between;
}
</style>
